import { useEffect } from 'react'
import MUIDataTable from 'mui-datatables'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../app/stores/store'
import ComponentLoader from './loaders/ComponentLoader'
import { formatToLocalDate } from '../../app/helpers'

function InvoicesTable() {
  const { paymentStore, userStore } = useStore()
  const { t } = useTranslation()

  useEffect(() => {
    paymentStore.loadPayments()
  }, [paymentStore])

  if (paymentStore.loadingPayments) return <ComponentLoader mTop={50} />

  const invoiceData = paymentStore.payments
    .filter((i) => i.email === userStore.user?.email && i.status === 1)
    .map((i) => ({
      name: i.name || 'John',
      surename: i.surename || 'Doe',
      email: i.email,
      price: `${(i.price / 100).toFixed(2)} CHF`,
      createdAt: formatToLocalDate(i.createdAt, useTranslation().i18n.language),
      invoiceId: i.invoiceId,
      packageName: i.packageName,
      auctionUse: i.auctionUse,
    }))

  const invoiceColumns = [
    { name: 'invoiceId', label: t('invoiceId') },
    { name: 'name', label: t('name') },
    { name: 'surename', label: t('surename') },
    { name: 'email', label: t('email') },
    { name: 'packageName', label: t('package') },
    { name: 'auctionUse', label: t('auctionUse') },
    { name: 'price', label: t('price') },
    { name: 'createdAt', label: t('createdAt') },
  ]

  return (
    <MUIDataTable
      title={t('invoice_list')}
      data={invoiceData}
      columns={invoiceColumns}
      options={{
        responsive: 'vertical',
        viewColumns: true,
        selectableRows: 'none',
        rowsPerPage: 10,
        rowsPerPageOptions: [5, 10, 15, 20],
        tableBodyHeight: '60vh',
        sortOrder: {
          name: 'invoiceId',
          direction: 'desc',
        },
      }}
    />
  )
}
export default observer(InvoicesTable)
